import { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import VideoCard from "../components/VideoCard";
import SkeletonRow from "../components/SkeletonRow";

export default function AICreative() {
    const [items, setItems] = useState([]);
    const [active, setActive] = useState("All");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            const it = await api.get("/ai-creative");
            setItems(it.data);
            setLoading(false);
        })();
    }, []);

    // Dynamically derive category tabs from items — no hardcoded list.
    const cats = useMemo(() => {
        const unique = new Set();
        items.forEach((it) => {
            const c = (it.category || "").trim();
            if (c) unique.add(c);
        });
        return ["All", ...Array.from(unique).sort((a, b) => a.localeCompare(b))];
    }, [items]);

    const filtered = active === "All" ? items : items.filter((i) => i.category === active);

    return (
        <div data-testid="ai-creative-page" className="pt-28 pb-16 mx-auto max-w-[1600px] px-6 lg:px-10">
            <div className="mb-6">
                <span className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#FFD400]">Premium Showcase</span>
                <h1 className="mt-2 font-display text-5xl sm:text-6xl font-black tracking-tight">AI Creative</h1>
            </div>

            <div data-testid="ai-cat-tabs" className="flex gap-2 flex-wrap mb-10">
                {cats.map((c) => (
                    <button
                        key={c}
                        data-testid={`ai-cat-${c.replace(/\s+/g, "-").toLowerCase()}`}
                        onClick={() => setActive(c)}
                        className={`text-xs font-semibold px-4 py-2 rounded-full transition-colors ${
                            active === c
                                ? "bg-[#FFD400] text-black"
                                : "bg-white/5 text-white/80 border border-white/10 hover:bg-white/10"
                        }`}
                    >
                        {c}
                    </button>
                ))}
            </div>

            {loading ? (
                <SkeletonRow />
            ) : filtered.length === 0 ? (
                <p className="text-white/50 text-sm" data-testid="ai-empty">No items in this category yet.</p>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    {filtered.map((v) => <VideoCard key={v.id} video={v} kind="ai" />)}
                </div>
            )}
        </div>
    );
}
